import React from 'react'
import PropTypes from 'prop-types'

export const Loading = () => {
    return (
        <div style={{width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center"}}>
            <div id='loading-content' className='loading-ellipsis'>
                <div/>
                <div/>
                <div/>
                <div/>
                {/*@ts-ignore*/}
                <style jsx='true' global='true'>
                    {`
                      #loading-content {
                        display: flex;
                        min-height: 56px;
                        min-width: 56px;
                      }

                      /* spinner css from https://loading.io/css/ */
                      .loading-ellipsis {
                        display: inline-block;
                        position: relative;
                        width: 64px;
                        height: 64px;
                      }

                      .loading-ellipsis div {
                        position: absolute;
                        top: 27px;
                        width: 11px;
                        height: 11px;
                        border-radius: 50%;
                        background: var(--pt-purple);
                        animation-timing-function: cubic-bezier(0, 1, 1, 0);
                      }

                      .loading-ellipsis div:nth-child(1) {
                        left: 6px;
                        animation: loading-ellipsis1 0.6s infinite;
                      }

                      .loading-ellipsis div:nth-child(2) {
                        left: 6px;
                        animation: loading-ellipsis2 0.6s infinite;
                      }

                      .loading-ellipsis div:nth-child(3) {
                        left: 26px;
                        animation: loading-ellipsis2 0.6s infinite;
                      }

                      .loading-ellipsis div:nth-child(4) {
                        left: 45px;
                        animation: loading-ellipsis3 0.6s infinite;
                      }

                      @keyframes loading-ellipsis1 {
                        0% {
                          transform: scale(0);
                        }
                        100% {
                          transform: scale(1);
                        }
                      }

                      @keyframes loading-ellipsis3 {
                        0% {
                          transform: scale(1);
                        }
                        100% {
                          transform: scale(0);
                        }
                      }

                      @keyframes loading-ellipsis2 {
                        0% {
                          transform: translate(0, 0);
                        }
                        100% {
                          transform: translate(19px, 0);
                        }
                      }
                    `}
                </style>
            </div>
        </div>
    )
}